import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import pauseApi from "../apis/pauseApi";

export const pauseQueryOptions = queryOptions({
  queryKey: ["pause"],
  queryFn: async () => pauseApi.unfinished(),
});

export const fetchPausedQueryOptions = queryOptions({
  queryKey: ["fetch_paused"],
  queryFn: async () => pauseApi.fetch(),
});

export const usePauseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (labnumbers: readonly (string | number)[]) =>
      pauseApi.pause(labnumbers),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: pauseQueryOptions.queryKey });
      queryClient.invalidateQueries({
        queryKey: fetchPausedQueryOptions.queryKey,
      });
    },
  });
};
